import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreakpointsService {
  public isMobile: WritableSignal<boolean> = signal(false);
  
  private _breakpointObserver = inject(BreakpointObserver);

  constructor() {
    this._breakpointObserver.observe(['(max-width: 834px)']).subscribe(result => {
      this.isMobile.set(result.matches);
    });
  }
}
